import './applied_filter_view.js.coffee';# Added by Script 
Namespace 'Monitoring.Views.SocialContents.Filters'

class Monitoring.Views.SocialContents.Filters.AppliedGmbCountriesFilterView extends
      Monitoring.Views.SocialContents.Filters.AppliedFilterView
  name: 'gmb_countries'
  humanize: true
  unmodifiableByModerators: false

  initialize: ({searchQuery}) ->
    super({searchQuery: searchQuery})
    @alias = I18n.t('monitoring.dashboard.filters.gmb_countries')

  removeFilter: (value) ->
    @searchQuery.removeGmbCountry(value)

  getDescription: (countryCode) ->
    countryName = @getCountryNameFromCode(countryCode) || countryCode
    super(countryName)

  getCountryNameFromCode: (countryCode) ->
    _.findKey(window.countryCodesByName, (value) => value == countryCode)
